import React from "react";
import { ArrowUpRight } from "lucide-react";
const HouseMap: React.FC = () => {
  const restaurants = [
    {
      name: "Nomi",
      subtitle: "7th Floor",
      url: "https://www.instagram.com/nomimumbai?igsh=dHZoODl5aXZ1NnF3",
      icon: "nomi.png",
    },
    {
      name: "Rasmanthan",
      subtitle: "3rd Floor",
      url: "https://www.instagram.com/rasmanthanindia?igsh=ZDY5cG5vbGk3dDR6",
      icon: "rasmanthan.jpg",
    },
    {
      name: "The Terrace – A Maiden Affair",
      subtitle: "5th Floor",
      url: "https://www.instagram.com/theterrace.amaidenaffair?igsh=d3M0cDBwbXJrNWlz",
      icon: "theterrace.jpg",
    },
  ];

  return (
    <section className="hobmap-section">
      <div className="hobmap-container">
        <h2 className="hobmap-title">The houses that came before this one</h2>

        <p className="hobmap-description">
          House of Bombay may be our newest table, but it is not our first.
          Before bringing this story to New Jersey, we spent years building
          restaurants in Bombay, each with its own point of view, personality,
          and loyal community of guests.
        </p>

        <div className="hobmap-map-wrapper">
          <img src="/hob.webp" alt="Mumbai Map" className="hobmap-map-image" />
        </div>

        <div className="hobmap-links">
          {restaurants.map((item, index) => (
            <a
              key={index}
              href={item.url}
              target="_blank"
              className="hobmap-link"
            >
              <img
                src={`/${item.icon}`}
                alt={item.name}
                style={{ width: "60px" }}
              />
              {item.name}
              <span className="hobmap-arrow">
                <ArrowUpRight />
              </span>
            </a>
          ))}
        </div>
      </div>

      {/* <div className="hobmap-bottom-line"></div> */}
    </section>
  );
};

export default HouseMap;
